import * as React from 'react';

/**
 * Info SVG component
 *
 * @returns
 */
function InfoSVG(svgProps: SVGProps) {
	return (
		<svg
			viewBox="0 0 32 32"
			className={'icon icon-info ' + svgProps.class}
			focusable="false"
			aria-hidden="true"
			data-testid={svgProps.testId}
		>
			<path d="M17.578 11.192v-3.23h-3.154v3.23zM17.578 24.038v-9.616h-3.154v9.616zM16.008 0c8.802 0.020 15.931 7.16 15.931 15.965 0 8.817-7.148 15.965-15.965 15.965s-15.965-7.148-15.965-15.965c0-4.409 1.787-8.4 4.676-11.289v0c2.894-2.889 6.89-4.676 11.303-4.676 0.007 0 0.015 0 0.022 0h-0.001z" />
		</svg>
	);
}

InfoSVG.defaultProps = { class: '' };

export default InfoSVG;
